const classIn = {
  path: 'classIn/:courseId',
  component: resolve => require(['../../../pages/teacher/classin'], resolve),
  props: true
}

export default classIn



// WEBPACK FOOTER //
// ./src/router/teacher/classin/index.js